let showToastFn = null;

export const toastHelper = {
  register(fn) {
    showToastFn = fn;
  },
  show(success, message) {
    if (showToastFn) {
      showToastFn(success, message);
    } else {
      console.warn("Toast function not registered yet:", message);
    }
  },
};

export default toastHelper;
